import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import Promo from "@/pages/Promo";
import PlaySlip from "@/pages/PlaySlip";
import Legal from "@/pages/Legal";
import { AuthProvider } from "@/context/AuthContext";
import { AccessProvider } from "@/context/AccessContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AccessProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/promo" element={<Promo />} />
              <Route path="/slip" element={<PlaySlip />} />
              <Route path="/legal/:doc" element={<Legal />} />
              <Route path="/legal" element={<Legal />} />
            </Routes>
          </BrowserRouter>
        </AccessProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
